import * as React from 'react';

import { NotFound } from 'bundles/common/components/withNotFound';
import useCourseBySlug, { type CourseData } from 'bundles/course-v2/hooks/useCourseBySlug';

// Props that will be injected by this HOC
export type PropsFromWithCourseBySlug = {
  courseData?: CourseData;
  isLoadingCourseData: boolean;
};

// Props required by this HOC
type PropsRequiredByWithCourseBySlug = {
  courseSlug: string;
};

/**
 * HOC that fetches course data by slug using GraphQL - replacement for loadCourseV1
 */
const withCourseBySlug = <P extends PropsRequiredByWithCourseBySlug>(
  WrappedComponent: React.ComponentType<P & PropsFromWithCourseBySlug>
) => {
  const WithCourseData = (props: P) => {
    const { courseSlug } = props;
    const { courseData, loading, error } = useCourseBySlug(courseSlug);

    if (error) {
      return <NotFound />;
    }

    return <WrappedComponent {...props} courseData={courseData} isLoadingCourseData={loading} />;
  };

  return WithCourseData;
};

export default withCourseBySlug;
